/**
 * Document validation constants for different countries
 */

const DOCUMENT_VALIDATION = {
  // Peru RUC validation
  PERU: {
    RUC: {
      LENGTH: 11,
      PATTERN: /^\d{11}$/,
      DESCRIPTION: 'RUC must be exactly 11 digits for Peru',
    },
  },
};

export default DOCUMENT_VALIDATION;
